export default __webpack_public_path__ + "static/media/AboutUsimages.bf701450.png";